var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('transition',{attrs:{"name":"modal","appear":""}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container",class:_vm.width,style:(_vm.styleOverride)},[_vm._t("content")],2)])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }